import Canonical from "../../../components/common/layout/Canonical";
import RecruitmentHeader from "../../../components/common/layout/RecruitmentHeader";
// import Banner from "../../../components/corporate/recruitment/Banner";
import Category from "../../../components/corporate/recruitment/Category";
import Documents from "../../../components/corporate/recruitment/Documents";
// import DownloadApp from "../../../components/corporate/recruitment/DownloadApp";
import FeaturedJobs from "../../../components/corporate/recruitment/FeaturedJobs";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
// import { RecruitmentBg } from "../../../components/common/svg/AllSvg";

const Home = () => {
  useSitemap();

  return (
    <>
      <Canonical />
      <div className="w-full h-full">
        {/* style={{ background: "linear-gradient(70deg, #E8FCFF 0%, #EDFDFF 100%)" }}  */}
        <div className="w-full h-full bg-[#F6F9FC] dark:bg-bgDark">
          <RecruitmentHeader />
          {/*<Banner />*/}
        </div>
        {/*<div className="w-full">
          <RecruitmentBg />
        </div>*/}
      </div>
      <div id="home">
        <FeaturedJobs />

        <div className="dark:bg-bgDarkDull bg-white w-full h-full">
          <Category />
          <Documents />
          {/* <DownloadApp /> */}
        </div>
      </div>
    </>
  );
};

export default Home;